import {
    createRouter,
    createWebHashHistory
} from 'vue-router'

import index from '../views/index';
import city from '../views/city/index';
import courseList from '../views/course/list';
import courseDetail from '../views/course/detail';
import memberArea from '../views/member/memberArea';
import onlineLearning from '../views/onlineLearning/index';
import school from '../views/onlineLearning/school';
import personalCenter from '../views/personalCenter/index';
import coupon from '../views/personalCenter/coupon';
import setting from '../views/personalCenter/setting';
import passwordUpdate from '../views/personalCenter/passwordUpdate';
import realNameVerify from '../views/personalCenter/realNameVerify';
import cancelAccount from '../views/personalCenter/cancelAccount';
import orderList from '../views/shop/orderList';
import cart from '../views/shop/cart';
import orderConfirm from '../views/shop/orderConfirm';
import paySuccess from '../views/shop/paySuccess';
import learningCenter from '../views/learningCenter/index';
import notice from '../views/learningCenter/notice';
import message from '../views/message/index'; // 原版消息中心
import integralCenter from '../views/integralCenter/index';
import integralRecord from '../views/integralCenter/record';
import integralDetail from '../views/integralCenter/detail';
import teacher from '../views/teacher/index';
import searchList from '../views/course/searchList';
import noticeDetail from '../views/learningCenter/noticeDetail';
import appIntroduce from '../views/appIntroduce/index';
import privacyAgreement from "../views/appIntroduce/privacyAgreement";
import normalQuestion from "../views/normalQuestion/index.vue";
import examStart from "../views/onlineLearning/examStart.vue";
import examPaper from '@/views/onlineLearning/examPaper.vue';
import examFinish from "@/views/onlineLearning/examFinish.vue";
import testPaperCenter from "@/views/testPaperCenter/index.vue";
import examLogin from "@/views/onlineLearning/examLogin.vue";
import examRecordPaper from '@/views/onlineLearning/examRecordPaper.vue';
import examAnalysis from "@/views/onlineLearning/examAnalysis.vue";
import allianceDistribution from '@/views/appIntroduce/allianceDistribution.vue';
import examinationCenter from "@/views/examinationCenter/index.vue";
import examWaitResult from '@/views/onlineLearning/examWaitResult.vue';
import examPaperView from '@/views/examinationCenter/examPaperView.vue';
import examPaperOrderConfirm from '@/views/examinationCenter/examPaperOrderConfirm.vue';
import test from '../views/test/index';

const routes = [{
        path: '/',
        name: 'index',
        component: index
    },
    {
        path: '/city',
        name: 'city',
        component: city
    },
    {
        path: '/courseList',
        name: 'courseList',
        component: courseList
    },
    {
        path: '/courseDetail',
        name: 'courseDetail',
        component: courseDetail
    },
    {
        path: '/memberArea',
        name: 'memberArea',
        component: memberArea
    },
    {
        path: '/onlineLearning',
        name: 'onlineLearning',
        component: onlineLearning
    },
    {
        path: '/school',
        name: 'school',
        component: school
    },
    {
        path: '/personalCenter',
        name: 'personalCenter',
        component: personalCenter
    },
    {
        path: '/coupon',
        name: 'coupon',
        component: coupon
    },
    {
        path: '/setting',
        name: 'setting',
        component: setting
    },
    {
        path: '/passwordUpdate',
        name: 'passwordUpdate',
        component: passwordUpdate
    },
    {
        path: '/realNameVerify',
        name: 'realNameVerify',
        component: realNameVerify
    },
    {
        path: '/cancelAccount',
        name: 'cancelAccount',
        component: cancelAccount
    },
    {
        path: '/orderList',
        name: 'orderList',
        component: orderList
    },
    {
        path: '/cart',
        name: 'cart',
        component: cart
    },
    {
        path: '/orderConfirm',
        name: 'orderConfirm',
        component: orderConfirm
    },
    {
        path: '/paySuccess',
        name: 'paySuccess',
        component: paySuccess
    },
    {
        path: '/learningCenter',
        name: 'learningCenter',
        component: learningCenter
    },
    {
        path: '/notice',
        name: 'notice',
        component: notice
    },
    {
        path: '/message',
        name: 'message',
        component: message
    },
    {
        path: '/goEasy/pages/index',
        name: 'messageIndex',
        component: () => import('../views/goEasy/pages/index.vue'),
        redirect: "/goEasy/pages/conversations",
        children: [
			{
				name: "conversations",
				path: "/goEasy/pages/conversations",
				component: () => import('../views/goEasy/pages/conversations.vue'),
			},
			{
				name: "groups",
				path: "/goEasy/pages/groups/groups",
				component: () => import('../views/goEasy/pages/groups/groups.vue'),
			},
			{
				name: "contacts",
				path: "/goEasy/pages/contacts/contacts",
				component: () => import('../views/goEasy/pages/contacts/contacts.vue'),
			},
			{
				name: "myTeacher",
				path: "/goEasy/pages/contacts/my-teacher",
				component: () => import('../views/goEasy/pages/contacts/my-teacher.vue'),
			},
			{
				name: "systemMessage",
				path: "/views/message/components/systemMessage",
				component: () => import('../views/message/components/systemMessage.vue'),
			},
            {
				name: "comment",
				path: "/views/message/components/comment",
				component: () => import('../views/message/components/comment.vue'),
			},
            {
				name: "giveUp",
				path: "/views/message/components/giveUp",
				component: () => import('../views/message/components/giveUp.vue'),
			},
            {
                name: "privateCall",
                path: "/goEasy/pages/privateCall",
                component: () => import('../views/goEasy/pages/rtc/private/call.vue'),
            },
            {
                name: "privateRing",
                path: "/goEasy/pages/privateRing",
                component: () => import('../views/goEasy/pages/rtc/private/ring.vue'),
            },
            {
                name: "privateDial",
                path: "/goEasy/pages/privateDial",
                component: () => import('../views/goEasy/pages/rtc/private/dial.vue'),
            },
            {
                name: "groupCall",
                path: "/goEasy/pages/groupCall",
                component: () => import('../views/goEasy/pages/rtc/group/call.vue'),
            },
            {
                name: "groupRing",
                path: "/goEasy/pages/groupRing",
                component: () => import('../views/goEasy/pages/rtc/group/ring.vue'),
            },
            {
                name: "groupDial",
                path: "/goEasy/pages/groupDial",
                component: () => import('../views/goEasy/pages/rtc/group/dial.vue'),
            },
            {
                name: "groupChooseCallee",
                path: "/goEasy/pages/groupChooseCallee",
                component: () => import('../views/goEasy/pages/rtc/group/chooseCallee.vue'),
            },
		],
	},
    {
        path: '/integralCenter',
        name: 'integralCenter',
        component: integralCenter
    },
    {
        path: '/integralRecord',
        name: 'integralRecord',
        component: integralRecord
    },
    {
        path: '/integralDetail',
        name: 'integralDetail',
        component: integralDetail
    },
    {
        path: '/teacher',
        name: 'teacher',
        component: teacher
    },
    {
        path: '/searchList',
        name: 'searchList',
        component: searchList
    },{
        path: '/noticeDetail',
        name: 'noticeDetail',
        component: noticeDetail
    },{
        path: '/appIntroduce',
        name: 'appIntroduce',
        component: appIntroduce
    },{
        path: '/privacyAgreement',
        name: 'privacyAgreement',
        component: privacyAgreement
    },{
        path: '/normalQuestion',
        name: 'normalQuestion',
        component: normalQuestion
    },{
        path: '/examStart',
        name: 'examStart',
        component: examStart
    },{
        path: '/examPaper',
        name: 'examPaper',
        component: examPaper
    },{
        path: '/examFinish',
        name: 'examFinish',
        component: examFinish
    },{
        path: '/testPaperCenter',
        name: 'testPaperCenter',
        component: testPaperCenter
    },{
        path: '/examLogin',
        name: 'examLogin',
        component: examLogin
    },{
        path: '/examRecordPaper',
        name: 'examRecordPaper',
        component: examRecordPaper
    },{
        path: '/examAnalysis',
        name: 'examAnalysis',
        component: examAnalysis
    },{
        path: '/allianceDistribution',
        name: 'allianceDistribution',
        component: allianceDistribution
    },{
        path: '/examinationCenter',
        name: 'examinationCenter',
        component: examinationCenter
    },{
        path: '/examWaitResult',
        name: 'examWaitResult',
        component: examWaitResult
    },{
        path: '/examPaperView',
        name: 'examPaperView',
        component: examPaperView
    },{
        path: '/examPaperOrderConfirm',
        name: 'examPaperOrderConfirm',
        component: examPaperOrderConfirm
    },
    {
        path: '/test',
        name: 'test',
        component: test
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    // 页面跳转回到顶部
    scrollBehavior() {
        window.scrollTo(0, 0);
    }
})

export default router